define('ch_points',[
    'jquery',
    'ch_selectors',
    'ch_modal_window',
    'ch_ga',
], function ($) {
    $(function () {
        $._('course_points').on('click', function (e) {
            e.preventDefault();
            var ModalWindowRewardPointsObj = new ModalWindowRewardPoints();
            ModalWindowRewardPointsObj.show({
                autofocus: false
            });
            ga('send', 'event', 'Loyalty Benefits', 'Points Popup Opened', window.location.href, {
                nonInteraction: false,
            });
        });

        var $pointsPopup = $('.points-nav-popup');
        var $pointsNav = $('.points-nav');

        if ($pointsNav && $pointsPopup) {
            require(['semantic'], function() {
                $pointsNav.popup({
                    popup : $pointsPopup,
                    position: 'bottom center',
                    on: 'hover',
                    transition: 'vertical flip'
                });
            });
        }

        var $profilePopup = $('.profile-popup');
        var $profileIcon = $('.profile-icon');

        if ($profileIcon && $profilePopup) {
            require(['semantic'], function() {
                $profileIcon.popup({
                    popup : $profilePopup,
                    position: 'bottom right',
                    on: 'hover',
                    hoverable: true
                });
            });
        }
    });
});

